import { FaRegHandshake } from "react-icons/fa"
import { BiLineChartDown, BiLineChart, BiExit } from "react-icons/bi"
import { AiOutlineAlert } from "react-icons/ai"
import { BiTimer } from "react-icons/bi"

export const menu = [
  {
    title: "Deals",
    path: "/",
    icon: FaRegHandshake,
  },
  {
    title: "Open Positions",
    path: "/open-positions",
    icon: FaRegHandshake,
  },
  {
    title: "Open Pos In N Days",
    path: "/open-positions-days",
    icon: FaRegHandshake,
  },
  {
    title: "Most Profitable",
    path: "/most-profitable",
    icon: BiLineChart,
  },
  {
    title: "Most Losses",
    path: "/most-losses",
    icon: BiLineChartDown,
  },
  {
    title: "Scam Trades",
    path: "/scam-trades",
    icon: AiOutlineAlert,
  },
  {
    title: "Frequent Trades",
    path: "/frequent-trades",
    icon: BiTimer,
  },
  {
    title: "Logout",
    path: "/logout",
    icon: BiExit,
  },
]
